import CreateHomeInfoContainer from "../containers/CreateHomeInfoContainer";

const CreateHomeInfoPage = () => {
  return (
    <CreateHomeInfoContainer />
  );
};

export default CreateHomeInfoPage;
